import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import apiRoutes from '@/lib/apiRoutes';
import { opstechHttpClient } from '@/lib/httpClient';
import type { DefaultQueryError } from '../types';
import type {
  AutocompleteData,
  AutocompleteParams,
  DetailParams,
  DetailResponse,
  Feature,
} from './types';

export const getDetailFn = async (params: DetailParams) => {
  const response = await opstechHttpClient.get<DetailResponse>(
    apiRoutes.place.detail,
    {
      params,
    }
  );
  return response.data;
};

const getDetailListFeature = (features: Feature[]) => {
  return Promise.all(
    features.map(async (item) => {
      const paramsDetail = {
        place_id: item.properties.place_id,
        sessiontoken: item.properties.sessiontoken,
      } as DetailParams;
      const responseDetail = await getDetailFn(paramsDetail);
      const data = responseDetail;
      item.properties.address = data.formatted_address;
      item.geometry = {
        coordinates: [data.geometry.location.lng, data.geometry.location.lat],
        type: '',
      };
      return item;
    })
  )
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch(() => {
      return new Array<Feature>();
    });
};

export const getAutocompleteFn = async (params: AutocompleteParams) => {
  if (params.mode === 'google') {
    const response = await opstechHttpClient.get<AutocompleteData>(
      apiRoutes.place.autocomplete_google,
      {
        params: {
          text: params.input,
          'focus.point.lon': params.lng,
          'focus.point.lat': params.lat,
          city_id: 'DAD',
        },
      }
    );

    const features = await getDetailListFeature(response.data.features);
    return {
      features: features,
    } as AutocompleteData;
  } else {
    const response = await opstechHttpClient.get<AutocompleteData>(
      apiRoutes.place.autocomplete,
      {
        params: {
          text: params.input,
          'focus.point.lon': params.lng,
          'focus.point.lat': params.lat,
          city_id: 'DAD',
        },
      }
    );
    return response.data;
  }
};

export const useGetAutocomplete = (
  params: AutocompleteParams,
  opts?: UseQueryOptions<AutocompleteData, DefaultQueryError>
) =>
  useQuery<AutocompleteData, DefaultQueryError>(
    [apiRoutes.place.autocomplete, params],
    () => getAutocompleteFn(params),
    opts
  );
